import { useI18N } from "@sundae/react-hooks";
import sortBy from "lodash/sortBy";
import { useMemo } from "react";
import { EGuideChapter, IChapter } from "../../../../stores/ControlCenterContext";
import { useV3ComparisonGuideJoyride } from "../guides/useV3ComparisonGuideJoyride";
// import { useV3CreatePoolGuideJoyride } from "../guides/useV3CreatePoolGuideJoyride";
// import { useV3MigrationGuideJoyride } from "../guides/useV3MigrationGuideJoyride";

export const useV3JoyrideChapter = (): IChapter => {
  const { t } = useI18N("joyride");
  const v3ComparisonGuide = useV3ComparisonGuideJoyride();
  // Disable other guides for pending videos to do on mainnet
  // const v3CreatePoolGuide = useV3CreatePoolGuideJoyride();
  // const v3MigrationGuide = useV3MigrationGuideJoyride();

  return useMemo(() => {
    return {
      id: EGuideChapter.V3,
      title: t("v3.title"),
      description: t("v3.description"),
      guides: sortBy([v3ComparisonGuide], "rank", "asc"),
    };
  }, [t, v3ComparisonGuide]);
};
